type TGameSearchPageContainerData = {
  keyword?: string;
  gameEmphasisVariation?: string;
};

// Container IDs
export const navigationContainerId = 'navigation-container';
export const navigationContainer = (): HTMLElement | null =>
  document.getElementById(navigationContainerId);
export const gameSearchPageContainerId = 'games-search-page';
export const gameSearchPageContainer = (): HTMLElement | null =>
  document.getElementById(gameSearchPageContainerId);

// Container Data Objects
export const isAutocompleteSuggestionsIXPTestEnabled = (): boolean =>
  parseInt(
    document.getElementById(navigationContainerId)?.dataset.numberOfAutocompleteSuggestions || '',
    10
  ) > 0;
export const gameSearchPageContainerData = (): TGameSearchPageContainerData | undefined =>
  document.getElementById(gameSearchPageContainerId)?.dataset;

// URL Params
export const queryParams = {
  keyword: 'keyword',
  gameSearchQuerySession: 'session'
};

// URL Paths
export const url = {
  sortDetail: (sortName: string): string => `games#/sortName/v2/${sortName}`
};
